//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex'

import ContextMenuBase from "../contextMenu/ContextMenuBase.vue"
import ContextMenuGroup from "../contextMenu/ContextMenuGroup.vue"
import ContextMenuItem from "../contextMenu/ContextMenuItem.vue"
import {
    USERDATA,
    VIDEO_CONF_NEW,
} from "../../store/modulesNames"
import {
    GET_ACTIVE_WEBCAMERA,
    GET_MEDIA_DEVICES_BY_KIND,
    GET_VC_CONF_MEDIA_DEVICE_BY_KIND,
} from "../../store/gettersTypes"
import {
    ACT_VC_CONF_SET_DEVICE,
} from "../../store/actionsTypes"

import videoConfMixin from "./videoConfMixin"
import contextMenuMixin from "../contextMenu/ContextMenuMixin"
import { MEDIA_DEVICES } from "../../constants"

export default {
    name: "videoConfCamSelect",
    components: { ContextMenuItem, ContextMenuGroup, ContextMenuBase },
    mixins: [videoConfMixin, contextMenuMixin],
    computed: {
        list() {
            let selected = this[GET_VC_CONF_MEDIA_DEVICE_BY_KIND](...this.confIdGetterData, MEDIA_DEVICES.VIDEO_INPUT)
            return this[GET_MEDIA_DEVICES_BY_KIND](MEDIA_DEVICES.VIDEO_INPUT).map(device => {
                return {
                    id: device.deviceId,
                    text: device.label,
                    selected: device.deviceId === selected,
                    kind: MEDIA_DEVICES.VIDEO_INPUT,
                }
            })
        },
        ...mapGetters(USERDATA, [GET_ACTIVE_WEBCAMERA, GET_MEDIA_DEVICES_BY_KIND]),
        ...mapGetters(VIDEO_CONF_NEW, [GET_VC_CONF_MEDIA_DEVICE_BY_KIND]),
    },
    methods: {
        onSelected(kind, deviceId) {
            this[ACT_VC_CONF_SET_DEVICE]({...this.confIdActionData, kind, deviceId})
        },
        ...mapActions(VIDEO_CONF_NEW, [ACT_VC_CONF_SET_DEVICE])
    }
}
